<template>
  <b-card
    v-if="canViewFirstAndOneTime && $can('write', 'first-time-transaction')"
  >
    <div class="d-flex justify-content-between align-items-center">
      <h3>First and one time transaction</h3>
      <b-button
        variant="primary"
        :disabled="submitting || !transactionForm.remarkText"
        @click="submitTransaction"
      >
        <b-spinner
          v-if="submitting"
          small
        />
        <span v-else>Apply</span>
      </b-button>
    </div>
    <h6>Transaction type: Registrations</h6>
    <small>Amount: {{ transactionForm.creditAmount }}</small>
    <b-form-group
      label="Remark Text"
      label-for="remark-text"
      class="mt-1"
    >
      <b-form-input
        id="remark-text"
        v-model="transactionForm.remarkText"
      />
    </b-form-group>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BSpinner, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { computed, ref, watch } from '@vue/composition-api'
import store from '@/store'
import { successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard, BButton, BSpinner, BFormGroup, BFormInput,
  },
  setup(_, ctx) {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const userCountry = userData?.country || 'JO'

    const isLicensed = computed(() => ctx.root.$store.getters['driverView/getLicenseStatus'])

    const canViewFirstAndOneTime = ref(false)
    const walletId = computed(() => store.getters['driverView/getWalletId'])
    const user = computed(() => store.getters['auth/getLoggedUser'])
    const transactionForm = ref({
      transactionTypeId: null,
      walletId: walletId.value,
      creditAmount: userCountry === 'JO' ? 5 : 10, // fixed
      debitAmount: 0,
      remarkText: '',
      addedBy: user.value.email,
    })

    const unResolvedList = computed(() => store.getters['driverView/getUnResolvedInactivations'])
    const types = computed(() => store.getters['transactionTypes/getTransactionTypes'] || [])
    const driverTransactions = computed(() => store.getters['driverView/getDriverTransactions'])

    watch([unResolvedList, types, driverTransactions], () => {
      const inactivationKeyFound = unResolvedList.value.find(el => el.created_by === 'System' && el.inactivation_reason === 'Admin' && el.note === 'New Registration')
      canViewFirstAndOneTime.value = driverTransactions.value?.transactions?.length === 0 && inactivationKeyFound && !isLicensed.value
      if (types.value.length) {
        const transactionTypeId = types.value.find(typ => typ.first_and_one_time)
        transactionForm.value.transactionTypeId = transactionTypeId.id
      }
    }, { deep: true })

    const submitting = ref(false)
    const submitTransaction = async () => {
      try {
        submitting.value = true
        await store.dispatch('driverView/addDriverTransaction', {
          transaction: transactionForm.value,
          id: ctx.root.$route.query.externalId,
        })
          .then(() => {
            successNotification('Transaction Saved Successfully')
            ctx.emit('added')
          })
      } finally {
        submitting.value = false
      }
    }
    return {
      submitTransaction,
      submitting,
      canViewFirstAndOneTime,
      unResolvedList,
      types,
      driverTransactions,
      transactionForm,
      isLicensed,
    }
  },
}
</script>

<style>

</style>
